function verificationStatus(status, icons) {
  switch (status) {
    case 'UNVERIFIED':
      return {
        icon: icons.mdiCloudOffOutline,
        text: 'Not uploaded',
        color: '#FF9800',
        status: 'Not uploaded',
      };
    case 'PENDING':
      return {
        icon: icons.mdiCloudOutline,
        text: 'Will not checked yet',
        color: 'skyblue',
        status: 'Pending validation',
      };
    case 'INVALID':
      return {
        icon: icons.mdiCloseCircleOutline,
        text: 'Will checked but invalid',
        color: '#ED1623',
        status: 'Invalid',
      };
    case 'VALID':
      return {
        icon: icons.mdiCheckCircleOutline,
        text: 'Will checked and valid',
        color: '#429378',
        status: 'Valid',
      };
    case 'VALIDITY_INCONCLUSIVE':
      return {
        icon: icons.mdiHelpCircleOutline,
        text: 'Will could not be verified',
        color: '#ED1623',
        status: 'Validity inconclusive',
      };
    default:
      return {
        icon: icons.mdiCloudOffOutline,
        text: 'Will not uploaded',
        color: '#ED1623',
        status: 'Not uploaded',
      };
  }
}

function latestWillVersion(willVersions) {
  const latestWillVersion = willVersions.reduce(
    (latest, willVersion) =>
      parseInt(latest.version) > willVersion.version ? latest : willVersion,
    { version: 0 }
  );

  return latestWillVersion.id ? latestWillVersion : null;
}

function latestUploadedWill(willVersions) {
  const latestWill = latestWillVersion(willVersions);
  if (latestWill) {
    const latestUploadedWill = latestWill.uploadedWills.reduce(
      (latest, uploadedWill) =>
        latest.version > uploadedWill.version ? latest : uploadedWill,
      { version: 0 }
    );

    return latestUploadedWill.id ? latestUploadedWill : null;
  } else {
    return null;
  }
}

function latestValidUploadedWill(willVersions) {
  const latestValidWillVersion = willVersions.reduce(
    function (latestValid, willVersion) {
      return willVersion.status == 'VALID' &&
        willVersion.version > latestValid.version
        ? willVersion
        : latestValid;
    },
    { version: 0 }
  );

  if (latestValidWillVersion.id) {
    const latestValidUploadedWill = latestValidWillVersion.uploadedWills.reduce(
      (latest, uploadedWill) =>
        uploadedWill.status == 'VALID' && uploadedWill.version > latest.version
          ? uploadedWill
          : latest,
      { version: 0 }
    );

    return latestValidUploadedWill.id ? latestValidUploadedWill : null;
  } else {
    return null;
  }
}

export {
  verificationStatus,
  latestWillVersion,
  latestUploadedWill,
  latestValidUploadedWill,
};
